module.exports = __webpack_public_path__ + "img/background009.0fc09c7e.jpg";